export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drifthq/billing-components/node_modules/ramda/es/internal/_of.js
// module id = 2621
// module chunks = 0